(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-referral-info"]) return;
  try {
    
  /* Add any custom JS for the referral section if needed */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-vip-banner"]) return;
  try {
    
  /* If you need any custom JS for your banner, place it here. */

  } catch(e) { console.error(e); }
})();
})();
